<template>
  <div class="sub-navigation">
    <AtomTab
      v-for="({ title, slug }, index) in tabs"
      :key="index"
      :active="active === index"
      :size="size"
      :to="slug"
      @tab:click="onItemClicked(index)"
    >
      {{ title }}
    </AtomTab>
  </div>
</template>

<script setup>
// Emitter
const emit = defineEmits([
  'tab:click',
])

// Props
const props = defineProps({
  size: {
    default() {
      return 'l'
    },
    required: false,
    type: String,
    validator(value) {
      return ['m', 'l'].indexOf(value) !== -1
    },
  },
  tabs: {
    default() {
      return []
    },
    required: true,
    type: Array,
  },
})

// Refs
const active = ref(0)

// Methods
function onItemClicked(index) {
  active.value = index
  emit('tab:click', active.value)
}
</script>

<style lang="postcss" scoped>
.sub-navigation {
  @apply flex flex-row w-full overflow-auto;

  .tab {
    @apply flex flex-shrink-0 mx-5;

    &:first-child {
      @apply ml-0;
    }

    &:last-child {
      @apply mr-0;
    }
  }
}
</style>
